(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 45301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(8476);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sN": function() { return /* binding */ MenuItem; },
/* harmony export */   "v2": function() { return /* binding */ Menu; }
/* harmony export */ });
/* unused harmony export MenuItemGroup */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87379);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83852);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var _material_ui_core_Menu__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38396);
/* harmony import */ var _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85639);
/* harmony import */ var _material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(46869);
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(95757);
/* harmony import */ var _material_ui_core_ListSubheader__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(96837);
/* harmony import */ var _material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(55517);
/* harmony import */ var _material_ui_core_Collapse__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(66037);
/* harmony import */ var _material_ui_core_List__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(62822);
/* harmony import */ var mdi_react_CheckboxMarkedIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26514);
/* harmony import */ var mdi_react_CheckboxMarkedIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(mdi_react_CheckboxMarkedIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var mdi_react_CheckboxBlankOutlineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70811);
/* harmony import */ var mdi_react_CheckboxBlankOutlineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(mdi_react_CheckboxBlankOutlineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var mdi_react_FolderIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40016);
/* harmony import */ var mdi_react_FolderIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(mdi_react_FolderIcon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var mdi_react_FolderOpenIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81837);
/* harmony import */ var mdi_react_FolderOpenIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(mdi_react_FolderOpenIcon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74815);


















function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  .MuiListSubheader-root {\n    margin: 0.5rem 0;\n    line-height: initial;\n  }\n\n  .MuiListItemIcon-root {\n    margin-right: 1rem;\n    min-width: auto;\n  }\n\n  .MuiMenuItem-root {\n    padding-right: 1.5rem;\n    max-width: 300px;\n  }\n\n  .MuiMenuItem-root .MuiTypography-root {\n    white-space: initial;\n  }\n\n  .MuiDivider-root {\n    margin: 8px 0;\n  }\n\n  .MuiMenuItem-root.menu-quick-action {\n    margin: 0.5rem 0 0 1rem;\n    padding: 0.5rem;\n    height: 20px;\n    width: 20px;\n    border-radius: 50%;\n    color: ",
        ";\n\n    box-sizing: content-box;\n\n    &.active {\n      background-color: ",
        ";\n      color: ",
        ";\n\n      &.Mui-focused,\n      &:focus,\n      &:hover {\n        background-color: ",
        ";\n      }\n    }\n\n    .mdi-icon {\n      width: 20px;\n      height: 20px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  margin: -16px 0 0 16px;\n  width: 8px;\n  height: 8px;\n  border-radius: 100%;\n  background-color: ",
        ";\n  pointer-events: none;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var QUICK_ACTION_MARGIN_RIGHT = 4;
var MenuWithQuickActions = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_material_ui_core_Menu__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-173c44d0-0"
})(_templateObject(), _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.black */ .Il.black, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.primary */ .Il.primary, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.white */ .Il.white, (0,polished__WEBPACK_IMPORTED_MODULE_10__/* .darken */ ._j)(0.1, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.primary */ .Il.primary));
var Dot = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-173c44d0-1"
})(_templateObject1(), _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.primary */ .Il.primary);
var MenuQuickAction = function(param) {
    var id = param.id, icon = param.icon, title = param.title, active = param.active, disabled = param.disabled, index = param.index, onClick = param.onClick;
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(event) {
        return onClick(id, event);
    }, [
        id,
        onClick
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        "aria-label": title,
        style: {
            position: 'absolute',
            top: 8,
            left: index * (36 + QUICK_ACTION_MARGIN_RIGHT)
        },
        className: "menu-quick-action ".concat(active ? 'active' : ''),
        disabled: disabled,
        onClick: handleClick,
        children: icon
    }));
};
var MenuItem = function(_param) {
    var _disableRecursion = _param.disableRecursion, disableRecursion = _disableRecursion === void 0 ? false : _disableRecursion, props = _objectWithoutProperties(_param, [
        "disableRecursion"
    ]);
    var id = props.id, icon = props.icon, title = props.title, subtitle = props.subtitle, _content = props.content, content = _content === void 0 ? null : _content, _elementProps = props.elementProps, elementProps = _elementProps === void 0 ? {} : _elementProps, disabled = props.disabled, _selected = props.selected, selected = _selected === void 0 ? false : _selected, _checkbox = props.checkbox, checkbox = _checkbox === void 0 ? false : _checkbox, _dot = props.dot, dot = _dot === void 0 ? false : _dot, _inner = props.inner, inner = _inner === void 0 ? false : _inner, _items = props.items, items = _items === void 0 ? false : _items, href = props.href, onClick = props.onClick;
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(event) {
        return onClick && onClick(id, event);
    }, [
        id,
        onClick
    ]);
    if (items && !disableRecursion) return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MenuItemGroup, _objectSpread({}, props)));
    var menuItem = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, _objectSpread({
        selected: selected,
        onClick: handleClick,
        disabled: disabled,
        style: inner ? {
            paddingLeft: '2rem'
        } : {}
    }, elementProps, {
        children: [
            dot && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Dot, {}),
            (checkbox || !!icon) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                children: checkbox && !icon ? selected ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_CheckboxMarkedIcon__WEBPACK_IMPORTED_MODULE_3___default()), {
                    color: _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.primary */ .Il.primary,
                    size: 18
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_CheckboxBlankOutlineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                    size: 18
                }) : icon
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                primary: title,
                secondary: subtitle,
                style: {
                    wordBreak: 'break-word'
                }
            }),
            content
        ]
    }));
    if (href) {
        // Special case for mailto links, skip Next.js Link component
        if (typeof href === 'string' && href.startsWith('mailto:')) {
            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: href,
                children: menuItem
            }));
        }
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
            href: href,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                children: menuItem
            })
        }, id));
    } else {
        return menuItem;
    }
};

var MenuItemGroup = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), innerOpen = ref[0], setOpen = ref[1];
    var open = props.overrideOpen || innerOpen;
    if (!props.items || !props.items.length) return null;
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(id, event) {
        setOpen(function(value) {
            return !value;
        });
        if (props.onClick) props.onClick(id, event);
    }, [
        props.onClick,
        setOpen
    ]);
    var icon = open ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_FolderOpenIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
        size: 18
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_FolderIcon__WEBPACK_IMPORTED_MODULE_5___default()), {
        size: 18
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MenuItem, _objectSpread({
                icon: icon
            }, props, {
                onClick: handleClick,
                disableRecursion: true
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Collapse__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                in: open,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_List__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    component: "div",
                    disablePadding: true,
                    children: props.items.map(function(item, i) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MenuItem, _objectSpread({}, item, {
                            inner: true
                        }), i);
                    })
                })
            })
        ]
    }));
};
var Menu = function(_param) {
    var checkboxes = _param.checkboxes, _quickActions = _param.quickActions, quickActions = _quickActions === void 0 ? [] : _quickActions, _items = _param.items, items = _items === void 0 ? [] : _items, _width = _param.width, width = _width === void 0 ? null : _width, children = _param.children, props = _objectWithoutProperties(_param, [
        "checkboxes",
        "quickActions",
        "items",
        "width",
        "children"
    ]);
    var renderMenuItem = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(item) {
        if (item === null) return null;
        if (/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(item)) return item;
        var id = item.id, title = item.title, _elementProps = item.elementProps, elementProps = _elementProps === void 0 ? {} : _elementProps, header = item.header, checkbox = item.checkbox, href = item.href, items = item.items;
        var isCheckbox = checkbox || checkboxes;
        if (header) {
            if (!title) return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {}, id));
            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ListSubheader__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, _objectSpread({}, elementProps, {
                children: title
            }), id));
        }
        var menuItem = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MenuItem, _objectSpread({}, item, {
            checkbox: isCheckbox
        }), id);
        if (href) {
            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                href: href,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    children: menuItem
                })
            }, id));
        } else {
            return menuItem;
        }
    }, [
        checkboxes
    ]);
    // Because quick actions have to be implemented with absolute positioning
    // to preserve the tab item order for the menu, we will need to calculate
    // a width for the menu quick actions manually.
    // padding left + (padding right - quick action right margin) + quick action count * (quick action width + quick action right margin)
    var minMenuWidthFromQuickActions = 16 + (16 - QUICK_ACTION_MARGIN_RIGHT) + quickActions.length * (36 + QUICK_ACTION_MARGIN_RIGHT);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(MenuWithQuickActions, _objectSpread({}, props, {
        MenuListProps: {
            style: {
                paddingTop: quickActions.length ? 36 + 8 + 16 : 8,
                minWidth: minMenuWidthFromQuickActions,
                maxHeight: 500,
                width: width !== null && width !== void 0 ? width : 'auto'
            }
        },
        children: [
            (quickActions || []).map(function(item, index) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MenuQuickAction, _objectSpread({}, item, {
                    index: index
                }), item.id);
            }),
            items.map(renderMenuItem)
        ]
    })));
};



/***/ }),

/***/ 43221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ ListsListRow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44012);
/* harmony import */ var _material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50998);
/* harmony import */ var _material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46869);
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95757);
/* harmony import */ var _material_ui_core_ListItemSecondaryAction__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81860);
/* harmony import */ var _common_Constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72916);
/* harmony import */ var _Badge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44632);
/* harmony import */ var _listsUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26344);










var sharedListSubtitle = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    id: "lists.sharedTitle",
    defaultMessage: "Jaettu lista"
});
var ListsListRow = function(param) {
    var listID = param.listID, listTypeID = param.listTypeID, label = param.label, items = param.items, tabIndex = param.tabIndex, _inner = param.inner, inner = _inner === void 0 ? false : _inner, selected = param.selected, onSelect = param.onSelect;
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return onSelect(listID);
    }, [
        listID,
        onSelect
    ]);
    var isShared = listTypeID === _common_Constants__WEBPACK_IMPORTED_MODULE_2__/* .ListType.COMPANYLIST */ .RH.COMPANYLIST;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        tabIndex: tabIndex,
        selected: selected,
        button: true,
        onClick: handleClick,
        style: inner ? {
            paddingLeft: '2rem'
        } : {},
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: _listsUtils__WEBPACK_IMPORTED_MODULE_4__/* .listTypeToIcon */ .V2[listTypeID]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                primary: label || _listsUtils__WEBPACK_IMPORTED_MODULE_4__/* .listTypeToDefaultTitle */ .TX[listTypeID],
                secondary: isShared && sharedListSubtitle,
                style: {
                    wordBreak: 'break-word'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ListItemSecondaryAction__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                className: "ignore",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Badge__WEBPACK_IMPORTED_MODULE_3__/* .Badge */ .C, {
                    plain: true,
                    children: (items === null || items === void 0 ? void 0 : items.length) || 0
                })
            })
        ]
    }));
};


/***/ }),

/***/ 26344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V2": function() { return /* binding */ listTypeToIcon; },
/* harmony export */   "TX": function() { return /* binding */ listTypeToDefaultTitle; },
/* harmony export */   "B2": function() { return /* binding */ getListContactPersonDetails; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44012);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87379);
/* harmony import */ var mdi_react_ThumbUpIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64021);
/* harmony import */ var mdi_react_ThumbUpIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(mdi_react_ThumbUpIcon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var mdi_react_AlertDecagramIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50450);
/* harmony import */ var mdi_react_AlertDecagramIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(mdi_react_AlertDecagramIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var mdi_react_ClipboardTextIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13433);
/* harmony import */ var mdi_react_ClipboardTextIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(mdi_react_ClipboardTextIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _common_Constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72916);
/* harmony import */ var _context_useUser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95460);
/* harmony import */ var _company_CompanyLogo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60733);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74815);











function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 24px;\n  height: 24px;\n\n  figure {\n    position: absolute;\n    bottom: -7px;\n    right: -7px;\n    border: 2px solid ",
        " !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var DualIcon = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2c58221-0"
})(_templateObject(), _Theme__WEBPACK_IMPORTED_MODULE_8__/* .Color.white */ .Il.white);
var CompanyListIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function() {
    var ref;
    var companies = (0,_context_useUser__WEBPACK_IMPORTED_MODULE_6__/* .useUser */ .a)().companies;
    var logo = (ref = companies[0]) === null || ref === void 0 ? void 0 : ref.logo;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(DualIcon, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_ClipboardTextIcon__WEBPACK_IMPORTED_MODULE_4___default()), {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_company_CompanyLogo__WEBPACK_IMPORTED_MODULE_7__/* .CompanyLogo */ .D, {
                size: 20,
                logo: logo
            })
        ]
    }));
});
var _obj;
var listTypeToIcon = (_obj = {}, _defineProperty(_obj, _common_Constants__WEBPACK_IMPORTED_MODULE_5__/* .ListType.LIKED */ .RH.LIKED, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_ThumbUpIcon__WEBPACK_IMPORTED_MODULE_2___default()), {
    color: _Theme__WEBPACK_IMPORTED_MODULE_8__/* .Color.green */ .Il.green
})), _defineProperty(_obj, _common_Constants__WEBPACK_IMPORTED_MODULE_5__/* .ListType.DISLIKED */ .RH.DISLIKED, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_AlertDecagramIcon__WEBPACK_IMPORTED_MODULE_3___default()), {
    color: _Theme__WEBPACK_IMPORTED_MODULE_8__/* .Color.red */ .Il.red
})), _defineProperty(_obj, _common_Constants__WEBPACK_IMPORTED_MODULE_5__/* .ListType.USERLIST */ .RH.USERLIST, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_ClipboardTextIcon__WEBPACK_IMPORTED_MODULE_4___default()), {})), _defineProperty(_obj, _common_Constants__WEBPACK_IMPORTED_MODULE_5__/* .ListType.COMPANYLIST */ .RH.COMPANYLIST, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CompanyListIcon, {})), _obj);
var _obj1;
var listTypeToDefaultTitle = (_obj1 = {}, _defineProperty(_obj1, _common_Constants__WEBPACK_IMPORTED_MODULE_5__/* .ListType.LIKED */ .RH.LIKED, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
    id: "lists.likedTitle",
    defaultMessage: "Tyk\xe4tyt"
})), _defineProperty(_obj1, _common_Constants__WEBPACK_IMPORTED_MODULE_5__/* .ListType.DISLIKED */ .RH.DISLIKED, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
    id: "lists.dislikedTitle",
    defaultMessage: "Huomioi"
})), _defineProperty(_obj1, _common_Constants__WEBPACK_IMPORTED_MODULE_5__/* .ListType.USERLIST */ .RH.USERLIST, null), _defineProperty(_obj1, _common_Constants__WEBPACK_IMPORTED_MODULE_5__/* .ListType.COMPANYLIST */ .RH.COMPANYLIST, null), _obj1);
var getListContactPersonDetails = function(_param) {
    var _ = _param.listContactPersonID, contactPerson = _param.contactPerson, role = _param.role, other = _objectWithoutProperties(_param, [
        "listContactPersonID",
        "contactPerson",
        "role"
    ]);
    if (contactPerson) {
        var firstname = contactPerson.firstname, lastname = contactPerson.lastname, title = contactPerson.title, email = contactPerson.email, phone = contactPerson.phone;
        return {
            name: "".concat(firstname, " ").concat(lastname).trim(),
            title: title,
            email: email,
            phone: phone,
            role: role
        };
    }
    return _objectSpread({}, other, {
        role: role
    });
};



/***/ }),

/***/ 36297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useOnScreen; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var useOnScreen = function(ref) {
    var ref1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _rootMargin = ref1.rootMargin, rootMargin = _rootMargin === void 0 ? '0px' : _rootMargin, _onlyOnce = ref1.onlyOnce, onlyOnce = _onlyOnce === void 0 ? false : _onlyOnce;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isVisible = ref2[0], setIsVisible = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var currentElement = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!currentElement) return;
        var observer = new IntersectionObserver(function(param) {
            var _param = _slicedToArray(param, 1), entry = _param[0];
            setIsVisible(function(state) {
                return onlyOnce ? state || entry.isIntersecting : entry.isIntersecting;
            });
        }, {
            rootMargin: rootMargin
        });
        if (currentElement) {
            observer.observe(currentElement);
        }
        return function() {
            observer.unobserve(currentElement);
        };
    }, [
        rootMargin
    ]);
    return isVisible;
};


/***/ }),

/***/ 26299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ recordCompanyVisit; },
/* harmony export */   "d": function() { return /* binding */ loadCompanyHistory; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var COMPANY_HISTORY_KEY = 'companyHistory';
var recordCompanyVisit = function(company) {
    var companyID = company.companyID, flags = company.flags, name = company.name, marketingName = company.marketingName, businessID = company.businessID, logo = company.logo;
    var companyHistoryItem = {
        companyID: companyID,
        flags: flags,
        name: name,
        marketingName: marketingName,
        businessID: businessID,
        logo: logo,
        timeVisited: new Date()
    };
    var history = loadCompanyHistory();
    var existingItemIndex = history.findIndex(function(item) {
        return item.companyID === companyID;
    });
    if (existingItemIndex >= 0) {
        history[existingItemIndex] = companyHistoryItem;
    } else {
        history.push(companyHistoryItem);
    }
    history.sort(function(a, b) {
        return b.timeVisited.valueOf() - a.timeVisited.valueOf();
    });
    saveCompanyHistory(history.slice(0, 6));
};
var saveCompanyHistory = function(history) {
    localStorage.setItem(COMPANY_HISTORY_KEY, JSON.stringify(history));
};
var loadCompanyHistory = function() {
    var history = JSON.parse(localStorage.getItem(COMPANY_HISTORY_KEY) || '[]');
    return history.map(function(item) {
        return _objectSpread({}, item, {
            timeVisited: new Date(item.timeVisited)
        });
    });
};


/***/ }),

/***/ 8476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 4 modules
var polished_esm = __webpack_require__(83852);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./node_modules/mdi-react/ArrowRightIcon.js
var ArrowRightIcon = __webpack_require__(45635);
var ArrowRightIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowRightIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/ShieldCheckIcon.js
var ShieldCheckIcon = __webpack_require__(97166);
var ShieldCheckIcon_default = /*#__PURE__*/__webpack_require__.n(ShieldCheckIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/BriefcaseSearchIcon.js
var BriefcaseSearchIcon = __webpack_require__(40783);
var BriefcaseSearchIcon_default = /*#__PURE__*/__webpack_require__.n(BriefcaseSearchIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/DiamondIcon.js
var DiamondIcon = __webpack_require__(87452);
var DiamondIcon_default = /*#__PURE__*/__webpack_require__.n(DiamondIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/HistoryIcon.js
var HistoryIcon = __webpack_require__(86006);
var HistoryIcon_default = /*#__PURE__*/__webpack_require__.n(HistoryIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/NewspaperVariantMultipleIcon.js
var NewspaperVariantMultipleIcon = __webpack_require__(42875);
var NewspaperVariantMultipleIcon_default = /*#__PURE__*/__webpack_require__.n(NewspaperVariantMultipleIcon);
// EXTERNAL MODULE: ./components/Header.tsx
var Header = __webpack_require__(18969);
// EXTERNAL MODULE: ./components/omnibar/Omnibar.tsx + 7 modules
var Omnibar = __webpack_require__(6717);
// EXTERNAL MODULE: ./components/Button.tsx
var Button = __webpack_require__(40570);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/mdi-react/TrophyIcon.js
var TrophyIcon = __webpack_require__(43741);
var TrophyIcon_default = /*#__PURE__*/__webpack_require__.n(TrophyIcon);
// EXTERNAL MODULE: ./lib/utils.ts + 1 modules
var utils = __webpack_require__(26482);
// EXTERNAL MODULE: ./components/Theme.ts
var Theme = __webpack_require__(74815);
;// CONCATENATED MODULE: ./components/SearchHero.tsx








function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 2rem;\n  margin-bottom: 2rem;\n  box-sizing: border-box;\n\n  p {\n    font-size: 1.1rem;\n    line-height: 1.5;\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  flex-shrink: 0;\n  width: 35rem;\n  height: 35rem;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n\n  box-sizing: border-box;\n\n  @media (max-width: ",
        "px) {\n    margin: 4rem 6rem;\n    height: 20rem;\n    border-radius: 1rem;\n  }\n\n  @media (max-width: ",
        "px) {\n    margin: 0 0 2rem 0 !important;\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 7rem auto 8rem auto;\n  max-width: 750px;\n  text-align: center;\n  background: none;\n  z-index: 1;\n\n  h2 {\n    margin-top: 2rem;\n    margin-bottom: 1.2rem;\n    font-weight: bold;\n\n    @media (max-width: ",
        "px) {\n      font-size: 2.5rem;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-flex;\n  padding: 1rem;\n  background-color: ",
        ";\n  border-radius: 50%;\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: 20rem;\n  margin-top: 2rem;\n\n  section {\n    display: flex;\n    align-items: center;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    padding: 0 4rem;\n    width: 100%;\n    max-width: 1920px;\n    min-height: 20rem;\n\n    box-sizing: border-box;\n\n    &.left {\n      > div {\n        margin-right: 0rem;\n      }\n\n      ",
        " {\n        filter: drop-shadow(-2.5rem 2.5rem 3rem rgba(0, 0, 0, 0.3));\n      }\n\n      ",
        " {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    &.right {\n      flex-direction: row-reverse;\n\n      > div {\n        margin-left: 0rem;\n      }\n\n      ",
        " {\n        filter: drop-shadow(2.5rem 2.5rem 3rem rgba(0, 0, 0, 0.5));\n      }\n\n      h3,\n      p {\n        text-align: right;\n      }\n    }\n\n    > div {\n      max-width: 600px;\n\n      h3 {\n        position: relative;\n        font-weight: bold;\n        font-size: 2.5rem;\n        margin-bottom: 1rem;\n\n        ",
        " {\n          position: absolute;\n          top: -5rem;\n          right: 0;\n        }\n      }\n\n      p {\n        opacity: 0.6;\n      }\n    }\n\n    @media (max-width: ",
        "px) {\n      flex-direction: column !important;\n    }\n\n    @media (max-width: ",
        "px) {\n      padding: 0;\n      margin-bottom: 5rem;\n\n      > div:last-child {\n        margin: 0;\n      }\n\n      h3,\n      p {\n        text-align: center !important;\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c984996f-0"
})(_templateObject());
var Img = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c984996f-1"
})(_templateObject1(), Theme/* breakPoint.medium */.dV.medium, Theme/* breakPoint.small */.dV.small);
var Info = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c984996f-2"
})(_templateObject2(), Theme/* breakPoint.small */.dV.small);
var Icon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c984996f-3"
})(_templateObject3(), Theme/* Color.primary */.Il.primary, Theme/* Color.background */.Il.background);
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c984996f-4"
})(_templateObject4(), Img, Icon, Img, Icon, Theme/* breakPoint.medium */.dV.medium, Theme/* breakPoint.small */.dV.small);
var SearchHero = function(param) {
    var children = param.children;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "right",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
                        style: {
                            backgroundImage: "url(".concat((0,utils/* imageFromCDN */.wg)('/search_mockup.png'), ")")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "h3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((TrophyIcon_default()), {
                                            size: 28
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "frontPage.showcase.constle.title",
                                        defaultMessage: "Keskity olennaiseen"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "frontPage.showcase.constle.text",
                                    defaultMessage: "Constle tarjoaa ratkaisuja helpottamaan rakennusalalla toimivien yritysten arkea. Voit yll\xe4pit\xe4\xe4 toimittajarekisteri\xe4, hakea tietoa muista yrityksist\xe4, sek\xe4 nostaa oman yrityksesi n\xe4kyvyytt\xe4 t\xe4ydent\xe4m\xe4ll\xe4 sen tietoja."
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./components/SEO.tsx
var SEO = __webpack_require__(81476);
// EXTERNAL MODULE: ./context/useUser.tsx
var useUser = __webpack_require__(95460);
// EXTERNAL MODULE: ./components/company-list/CompanyListRow.tsx
var CompanyListRow = __webpack_require__(51453);
// EXTERNAL MODULE: ./components/company-list/CompanyListStyle.tsx
var CompanyListStyle = __webpack_require__(31999);
// EXTERNAL MODULE: ./components/company-list/CompanyListRowSkeleton.tsx
var CompanyListRowSkeleton = __webpack_require__(23834);
;// CONCATENATED MODULE: ./components/search/CompanyCarousel.tsx









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CompanyCarousel_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyCarousel_templateObject() {
    var data = CompanyCarousel_taggedTemplateLiteral([
        ""
    ]);
    CompanyCarousel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyCarousel_templateObject1() {
    var data = CompanyCarousel_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    CompanyCarousel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanyCarousel_templateObject2() {
    var data = CompanyCarousel_taggedTemplateLiteral([
        "\n    flex-direction: row;\n    flex-wrap: wrap;\n    margin-top: -",
        "rem;\n    margin-left: -",
        "rem;\n    width: calc(100% + ",
        "rem);\n    max-width: none;\n    background: transparent;\n    box-shadow: none;\n\n    ",
        " {\n      border-radius: ",
        "px;\n      border: none;\n      ",
        "\n      margin: ",
        "rem;\n      width: calc(50% - ",
        "rem);\n\n      > a {\n        margin-top: 0;\n        border: none;\n      }\n    }\n  "
    ]);
    CompanyCarousel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompanyCarousel_templateObject3() {
    var data = CompanyCarousel_taggedTemplateLiteral([
        "\n    ",
        " {\n      margin: ",
        "rem;\n      width: calc(33.33% - ",
        "rem);\n    }\n  "
    ]);
    CompanyCarousel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CompanyCarousel_templateObject4() {
    var data = CompanyCarousel_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  ",
        "\n  padding: 0;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    CompanyCarousel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
var CompanyCarousel_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2eb7eb2-0"
})(CompanyCarousel_templateObject1(), Theme/* mediaQuery.mobileFirst.medium */.cy.mobileFirst.medium((0,styled_components_browser_esm/* css */.iv)(CompanyCarousel_templateObject())));
var itemSpacingRem = 0.4;
var List = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2eb7eb2-1"
})(CompanyCarousel_templateObject4(), Theme/* cardStyles */.F, Theme/* mediaQuery.mobileFirst.medium */.cy.mobileFirst.medium((0,styled_components_browser_esm/* css */.iv)(CompanyCarousel_templateObject2(), itemSpacingRem, itemSpacingRem, itemSpacingRem * 2, CompanyListStyle/* Row */.X2, Theme/* borderRadius */.E0, Theme/* cardStyles */.F, itemSpacingRem, itemSpacingRem * 2)), Theme/* mediaQuery.mobileFirst.large */.cy.mobileFirst.large((0,styled_components_browser_esm/* css */.iv)(CompanyCarousel_templateObject3(), CompanyListStyle/* Row */.X2, itemSpacingRem, itemSpacingRem * 2)));
var CompanyCarousel = function(param) {
    var title = param.title, _icon = param.icon, icon = _icon === void 0 ? null : _icon, _companies = param.companies, companies = _companies === void 0 ? [] : _companies, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    var loadingItems = (0,react.useMemo)(function() {
        return new Array(6).fill(null).map(function(_, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(CompanyListRowSkeleton/* CompanyListRowSkeleton */.F, {
                sections: [
                    'name'
                ]
            }, index);
        });
    }, []);
    var renderCompany = (0,react.useCallback)(function(company) {
        var url = (0,utils/* companyUrl */.c2)(_objectSpread({
            lang: 'fi'
        }, company));
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyListRow/* CompanyListRow */.gW, {
            company: _objectSpread({}, company, {
                url: url
            }),
            sections: [
                'name'
            ]
        }, company.companyID));
    }, [
        loading
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyCarousel_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                icon: icon,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List, {
                children: [
                    !loading && companies.map(renderCompany),
                    loading && loadingItems
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./lib/state.ts
var state = __webpack_require__(54442);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/index.js
var zustand = __webpack_require__(14894);
// EXTERNAL MODULE: ./node_modules/zustand/middleware.js
var middleware = __webpack_require__(14316);
;// CONCATENATED MODULE: ./context/recentlyUpdatedStore.tsx






function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var recentlyUpdatedStateDefaults = {
    companies: [],
    isLoaded: false,
    isLoading: true
};
/** Load state from API the first time front-page is opened */ var doLoadState = function(set, get) {
    return _asyncToGenerator(runtime_default().mark(function _callee() {
        var isLoaded, ref, status, companies;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    isLoaded = get().isLoaded;
                    if (!isLoaded) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        status: 'ok'
                    });
                case 3:
                    _ctx.next = 5;
                    return (0,utils/* nextApiRequest */.Qd)("/api/v1/www/company/recently-updated");
                case 5:
                    ref = _ctx.sent;
                    status = ref.status;
                    companies = ref.companies;
                    if (!(status !== 'ok')) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        status: status,
                        error: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "unknownError",
                            defaultMessage: "Jokin meni vikaan, yrit\xe4 my\xf6hemmin uudelleen…"
                        })
                    });
                case 10:
                    set({
                        companies: companies,
                        isLoaded: true,
                        isLoading: false
                    });
                    return _ctx.abrupt("return", {
                        status: 'ok'
                    });
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};
/** Store */ var recentlyUpdatedState = (0,zustand/* default */.Z)((0,middleware/* combine */.$e)(recentlyUpdatedStateDefaults, function(set, get) {
    return {
        /** State methods */ doLoadState: doLoadState(set, get),
        /** General set state */ set: set
    };
}));

// EXTERNAL MODULE: ./lib/companyHistory.ts
var lib_companyHistory = __webpack_require__(26299);
// EXTERNAL MODULE: ./node_modules/mdi-react/ClipboardTextMultipleIcon.js
var ClipboardTextMultipleIcon = __webpack_require__(14962);
var ClipboardTextMultipleIcon_default = /*#__PURE__*/__webpack_require__.n(ClipboardTextMultipleIcon);
// EXTERNAL MODULE: ./components/Badge.tsx
var Badge = __webpack_require__(44632);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/List.js
var List_List = __webpack_require__(62822);
// EXTERNAL MODULE: ./hooks/useBreakPoint.ts
var useBreakPoint = __webpack_require__(41894);
// EXTERNAL MODULE: ./hooks/useOnScreen.ts
var useOnScreen = __webpack_require__(36297);
;// CONCATENATED MODULE: ./components/frontpage/exampleListData.ts
function exampleListData_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function exampleListData_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            exampleListData_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var listGroups = [
    {
        listGroupID: 1024,
        label: '1. Maa ja pohja'
    },
    {
        listGroupID: 1025,
        label: '2. Perustukset ja ulkopuoliset'
    },
    {
        listGroupID: 1026,
        label: '3. Runko ja vesikatto'
    },
    {
        listGroupID: 1027,
        label: '4. T\xe4ydent\xe4v\xe4t'
    },
    {
        listGroupID: 1028,
        label: '5. Pintarakenteet'
    },
    {
        listGroupID: 1029,
        label: '6. Kalusteet ja varusteet'
    },
    {
        listGroupID: 1030,
        label: '7. Konetekniset'
    }, 
];
var demoListItem = {
    listItemID: 1,
    companyID: 1,
    name: 'Yritys',
    businessID: '1234567-0',
    email: '',
    isRegistered: false,
    isInvited: false,
    logo: null,
    domicile: {
        cityID: 13096,
        cityName: 'Kerava',
        provinceID: 12001,
        provinceName: 'Uusimaa',
        countryID: 11001,
        countryName: 'suomi'
    },
    companyContactPersons: [],
    listContactPersons: [],
    pendingContactPersonInvites: [],
    operationalAreaIDs: [],
    comments: [],
    url: '',
    yearlyBuys: null
};
var lists = [
    // Dummy lists
    {
        listID: 1,
        listTypeID: 100,
        label: 'List',
        listGroupID: 1024,
        items: []
    },
    {
        listID: 2,
        listTypeID: 100,
        label: 'List',
        listGroupID: 1027,
        items: []
    },
    {
        listID: 3,
        listTypeID: 100,
        label: 'List',
        listGroupID: 1029,
        items: []
    },
    {
        listID: 4,
        listTypeID: 100,
        label: 'List',
        listGroupID: 1030,
        items: []
    },
    // Preview list
    {
        listID: 6537,
        listTypeID: 100,
        label: 'ALAKATTOTY\xd6T',
        listGroupID: 1028,
        items: [
            {
                listItemID: 26384,
                companyID: 418801,
                name: 'Yritys 1 Oy',
                businessID: '1234567-0',
                email: '',
                isRegistered: false,
                isInvited: false,
                logo: null,
                domicile: {
                    cityID: 13275,
                    cityName: 'Tampere',
                    provinceID: 12006,
                    provinceName: 'Pirkanmaa',
                    countryID: 11001,
                    countryName: 'suomi'
                },
                companyContactPersons: [],
                listContactPersons: [],
                pendingContactPersonInvites: [],
                operationalAreaIDs: [],
                comments: [],
                url: '',
                yearlyBuys: null
            },
            {
                listItemID: 26381,
                companyID: 419280,
                name: 'Yritys Kaksi Oy',
                businessID: '1234567-0',
                email: '',
                isRegistered: false,
                isInvited: false,
                logo: null,
                domicile: {
                    cityID: 13018,
                    cityName: 'Forssa',
                    provinceID: 12005,
                    provinceName: 'Kanta-H\xe4me',
                    countryID: 11001,
                    countryName: 'suomi'
                },
                companyContactPersons: [],
                listContactPersons: [],
                pendingContactPersonInvites: [],
                operationalAreaIDs: [],
                comments: [],
                url: '',
                yearlyBuys: null
            },
            {
                listItemID: 26378,
                companyID: 425498,
                name: 'Yritys 3',
                businessID: '1234567-0',
                email: '',
                isRegistered: false,
                isInvited: false,
                logo: {
                    path: '/demoCompany1.png'
                },
                domicile: {
                    cityID: 13030,
                    cityName: 'Helsinki',
                    provinceID: 12001,
                    provinceName: 'Uusimaa',
                    countryID: 11001,
                    countryName: 'suomi'
                },
                companyContactPersons: [],
                listContactPersons: [],
                pendingContactPersonInvites: [],
                operationalAreaIDs: [],
                comments: [],
                url: '',
                yearlyBuys: null
            },
            {
                listItemID: 26376,
                companyID: 434302,
                name: 'Yritys Nelj\xe4 Ltd Oy',
                businessID: '1234567-0',
                email: '',
                isRegistered: false,
                isInvited: false,
                logo: null,
                domicile: {
                    cityID: 13080,
                    cityName: 'Karkkila',
                    provinceID: 12001,
                    provinceName: 'Uusimaa',
                    countryID: 11001,
                    countryName: 'suomi'
                },
                companyContactPersons: [],
                listContactPersons: [],
                pendingContactPersonInvites: [],
                operationalAreaIDs: [],
                comments: [],
                url: '',
                yearlyBuys: null
            },
            {
                listItemID: 26380,
                companyID: 443060,
                name: 'Yritys 5 Oy Ab',
                businessID: '1234567-0',
                email: '',
                isRegistered: false,
                isInvited: false,
                logo: null,
                domicile: {
                    cityID: 13140,
                    cityName: 'Lahti',
                    provinceID: 12007,
                    provinceName: 'P\xe4ij\xe4t-H\xe4me',
                    countryID: 11001,
                    countryName: 'suomi'
                },
                companyContactPersons: [],
                listContactPersons: [],
                pendingContactPersonInvites: [],
                operationalAreaIDs: [],
                comments: [],
                url: '',
                yearlyBuys: null
            },
            {
                listItemID: 26370,
                companyID: 452978,
                name: 'Yritys 6',
                businessID: '1234567-0',
                email: '',
                isRegistered: false,
                isInvited: false,
                logo: null,
                domicile: {
                    cityID: 13030,
                    cityName: 'Helsinki',
                    provinceID: 12001,
                    provinceName: 'Uusimaa',
                    countryID: 11001,
                    countryName: 'suomi'
                },
                companyContactPersons: [],
                listContactPersons: [],
                pendingContactPersonInvites: [],
                operationalAreaIDs: [],
                comments: [],
                url: '',
                yearlyBuys: null
            }, 
        ]
    },
    // Preview list
    {
        listID: 3795,
        listTypeID: 4,
        label: 'LISTA',
        listGroupID: null,
        items: [
            exampleListData_objectSpread({}, demoListItem, {
                listItemID: 1
            }),
            exampleListData_objectSpread({}, demoListItem, {
                listItemID: 2
            }),
            exampleListData_objectSpread({}, demoListItem, {
                listItemID: 3
            }),
            exampleListData_objectSpread({}, demoListItem, {
                listItemID: 4
            }), 
        ]
    },
    {
        listID: 6510,
        listTypeID: 100,
        label: 'BETONIELEMENTIT',
        listGroupID: 1026,
        items: [
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem, 
        ]
    },
    {
        listID: 6517,
        listTypeID: 100,
        label: 'BETONISET PORRASELEMENTIT',
        listGroupID: 1026,
        items: [
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem
        ]
    },
    {
        listID: 3939,
        listTypeID: 4,
        label: 'LIST',
        listGroupID: null,
        items: [
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem
        ]
    },
    {
        listID: 3796,
        listTypeID: 4,
        label: 'LIST',
        listGroupID: null,
        items: []
    },
    {
        listID: 6511,
        listTypeID: 100,
        label: 'ELEMENTTIASENNUS',
        listGroupID: 1026,
        items: [
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem, 
        ]
    },
    {
        listID: 6508,
        listTypeID: 100,
        label: 'LATTIAVALUT',
        listGroupID: 1025,
        items: [
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem, 
        ]
    },
    {
        listID: 6506,
        listTypeID: 100,
        label: 'PERUSTALAUDOITUKSET YM',
        listGroupID: 1025,
        items: [
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem, 
        ]
    },
    {
        listID: 6507,
        listTypeID: 100,
        label: 'RAUDOITUS',
        listGroupID: 1025,
        items: [
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem,
            demoListItem, 
        ]
    }, 
];

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Collapse/Collapse.js
var Collapse = __webpack_require__(66037);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(50998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(46869);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(95757);
// EXTERNAL MODULE: ./node_modules/mdi-react/FolderIcon.js
var FolderIcon = __webpack_require__(40016);
var FolderIcon_default = /*#__PURE__*/__webpack_require__.n(FolderIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/FolderOpenIcon.js
var FolderOpenIcon = __webpack_require__(81837);
var FolderOpenIcon_default = /*#__PURE__*/__webpack_require__.n(FolderOpenIcon);
// EXTERNAL MODULE: ./components/lists/ListsListRow.tsx
var ListsListRow = __webpack_require__(43221);
;// CONCATENATED MODULE: ./components/frontpage/ListsShowcaseGroup.tsx











function ListsShowcaseGroup_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ListsShowcaseGroup_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ListsShowcaseGroup_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var handleSelect = function() {};
var ListsShowcaseGroup = function(param) {
    var listGroupID = param.listGroupID, label = param.label, _open = param.open, open = _open === void 0 ? false : _open;
    var items = (0,react.useMemo)(function() {
        return (lists.filter(function(list) {
            return list.listGroupID === listGroupID;
        }) || []).sort(function(a, b) {
            return a.label.localeCompare(b.label);
        });
    }, [
        listGroupID
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                tabIndex: -1,
                button: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                        style: {
                            opacity: items.length > 0 ? 1 : 0.6
                        },
                        children: open ? /*#__PURE__*/ (0,jsx_runtime.jsx)((FolderOpenIcon_default()), {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)((FolderIcon_default()), {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                        primary: label
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                in: open,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                    component: "div",
                    disablePadding: true,
                    children: items.map(function(list) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ListsListRow/* ListsListRow */.a, ListsShowcaseGroup_objectSpread({}, list, {
                            tabIndex: -1,
                            inner: true,
                            selected: false,
                            onSelect: handleSelect
                        }), list.listID);
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/frontpage/ListsShowcaseSidebar.tsx









function ListsShowcaseSidebar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ListsShowcaseSidebar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ListsShowcaseSidebar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ListsShowcaseSidebar_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ListsShowcaseSidebar_templateObject() {
    var data = ListsShowcaseSidebar_taggedTemplateLiteral([
        "\n  width: min(calc(100vw - 16px), 400px);\n  height: 325px;\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n  overflow: hidden;\n\n  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 80%, rgba(0, 0, 0, 0) 100%);\n  pointer-events: none;\n\n  > nav {\n    width: min(calc(100vw - 16px), 400px);\n\n    .logo {\n      background-image: url('/demoCompanyConstle.png') !important;\n\n      svg {\n        display: none;\n      }\n    }\n  }\n"
    ]);
    ListsShowcaseSidebar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var ListsShowcaseSidebar_Container = styled_components_browser_esm/* default.aside.withConfig */.ZP.aside.withConfig({
    componentId: "sc-6e61c05a-0"
})(ListsShowcaseSidebar_templateObject(), Theme/* Color.white */.Il.white, Theme/* borderRadius */.E0);
var ListsShowcaseSidebar = function() {
    var isSmall = (0,useBreakPoint/* useBreakPoint */.P)('small');
    var containerRef = (0,react.useRef)(null);
    var isVisible = (0,useOnScreen/* useOnScreen */.R)(containerRef, {
        rootMargin: "".concat(isSmall ? '-30%' : '-350px')
    });
    var ref = (0,react.useState)([]), openListGroupID = ref[0], setOpenListGroupID = ref[1];
    (0,react.useEffect)(function() {
        if (!isVisible) return;
        var animate = function() {
            return setOpenListGroupID(function(value) {
                if (value.length === 0) return [
                    1025
                ];
                if (value.length === 1) return [
                    1026,
                    1027
                ];
                return [];
            });
        };
        var timeout = setTimeout(animate, 500);
        var interval = setInterval(animate, 3000);
        return function() {
            clearTimeout(timeout);
            clearInterval(interval);
        };
    }, [
        isVisible
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ListsShowcaseSidebar_Container, {
        ref: containerRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
            tabIndex: -1,
            disablePadding: true,
            component: "nav",
            children: listGroups.map(function(listGroup, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ListsShowcaseGroup, ListsShowcaseSidebar_objectSpread({}, listGroup, {
                    open: openListGroupID.includes(listGroup.listGroupID)
                }), listGroup.listGroupID);
            })
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListSubheader/ListSubheader.js
var ListSubheader = __webpack_require__(96837);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(55517);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuList/MenuList.js
var MenuList = __webpack_require__(29829);
// EXTERNAL MODULE: ./node_modules/mdi-react/StoreIcon.js
var StoreIcon = __webpack_require__(27131);
var StoreIcon_default = /*#__PURE__*/__webpack_require__.n(StoreIcon);
// EXTERNAL MODULE: ./common/Constants.ts
var Constants = __webpack_require__(72916);
// EXTERNAL MODULE: ./components/Menu.tsx
var Menu = __webpack_require__(12825);
;// CONCATENATED MODULE: ./components/frontpage/ListsShowcaseMenu.tsx















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ListsShowcaseMenu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ListsShowcaseMenu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ListsShowcaseMenu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ListsShowcaseMenu_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function ListsShowcaseMenu_templateObject() {
    var data = ListsShowcaseMenu_taggedTemplateLiteral([
        "\n  width: min(calc(100vw - 16px), 400px);\n  height: 325px;\n  pointer-events: none;\n"
    ]);
    ListsShowcaseMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ListsShowcaseMenu_templateObject1() {
    var data = ListsShowcaseMenu_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n  overflow: hidden;\n\n  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 80%, rgba(0, 0, 0, 0) 100%);\n"
    ]);
    ListsShowcaseMenu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ListsShowcaseMenu_templateObject2() {
    var data = ListsShowcaseMenu_taggedTemplateLiteral([
        "\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: -58px;\n  right: 32px;\n  width: 42px;\n  height: 42px;\n  background-color: ",
        ";\n  border-radius: 50%;\n\n  > svg {\n    color: #696969;\n  }\n\n  &::after {\n    position: absolute;\n    content: '';\n    bottom: -16px;\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n\n    border-bottom: 8px solid ",
        ";\n  }\n\n  @media (max-width: ",
        "px) {\n    display: none;\n  }\n"
    ]);
    ListsShowcaseMenu_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ListsShowcaseMenu_templateObject3() {
    var data = ListsShowcaseMenu_taggedTemplateLiteral([
        "\n  position: relative;\n  padding-left: ",
        "px;\n\n  .mdi-icon {\n    position: absolute;\n    left: 0;\n    margin-top: 3px;\n    color: ",
        ";\n    opacity: 0.6;\n  }\n"
    ]);
    ListsShowcaseMenu_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var ListsShowcaseMenu_Container = styled_components_browser_esm/* default.aside.withConfig */.ZP.aside.withConfig({
    componentId: "sc-8a45999-0"
})(ListsShowcaseMenu_templateObject());
var ListsShowcaseMenu_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8a45999-1"
})(ListsShowcaseMenu_templateObject1(), Theme/* Color.white */.Il.white, Theme/* borderRadius */.E0);
var ListsShowcaseMenu_Button = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8a45999-2"
})(ListsShowcaseMenu_templateObject2(), (0,polished_esm/* transparentize */.DZ)(0.2, Theme/* Color.white */.Il.white), Theme/* Color.white */.Il.white, Theme/* breakPoint.small */.dV.small);
var ListTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-8a45999-3"
})(ListsShowcaseMenu_templateObject3(), function(param) {
    var shared = param.shared;
    return shared ? 18 + 6 : 0;
}, Theme/* Color.secondary */.Il.secondary);
var ListsShowcaseMenu = function() {
    var isSmall = (0,useBreakPoint/* useBreakPoint */.P)('small');
    var containerRef = (0,react.useRef)(null);
    var isVisible = (0,useOnScreen/* useOnScreen */.R)(containerRef, {
        rootMargin: "".concat(isSmall ? '-30%' : '-350px')
    });
    var ref = (0,react.useState)(0), openListGroupID = ref[0], setOpenListGroupID = ref[1];
    var ref1 = (0,react.useState)([]), selectedListIDs = ref1[0], setSelectedListIDs = ref1[1];
    var ref2 = (0,react.useState)(0), step1 = ref2[0], setStep = ref2[1];
    (0,react.useEffect)(function() {
        if (!isVisible) return;
        var animate = function() {
            return setStep(function(step) {
                if (step === 0) setOpenListGroupID(1025);
                if (step === 1) setSelectedListIDs([
                    6508
                ]);
                if (step === 2) setSelectedListIDs([
                    6508,
                    6506
                ]);
                if (step === 3) setSelectedListIDs([
                    6508,
                    6506,
                    6507
                ]);
                if (step === 6) setOpenListGroupID(0);
                if (step === 7) setSelectedListIDs([]);
                return (step + 1) % 10;
            });
        };
        var timeout = setTimeout(animate, 500);
        var interval = setInterval(animate, 1000);
        return function() {
            clearTimeout(timeout);
            clearInterval(interval);
        };
    }, [
        isVisible
    ]);
    var listToMenuItem = (0,react.useCallback)(function(list) {
        var isShared = list.listTypeID === Constants/* ListType.COMPANYLIST */.RH.COMPANYLIST;
        return {
            id: "".concat(list.listID),
            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListTitle, {
                shared: isShared,
                children: [
                    isShared && /*#__PURE__*/ (0,jsx_runtime.jsx)((StoreIcon_default()), {
                        size: 18
                    }),
                    list.label
                ]
            }),
            selected: selectedListIDs.includes(list.listID),
            checkbox: true,
            onClick: function() {}
        };
    }, [
        selectedListIDs
    ]);
    var listGroupToMenuItem = (0,react.useCallback)(function(param, index) {
        var listGroupID = param.listGroupID, label = param.label;
        return {
            id: "listGroup-".concat(listGroupID),
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTitle, {
                shared: false,
                children: label
            }),
            selected: false,
            checkbox: false,
            overrideOpen: openListGroupID === listGroupID,
            items: (lists.filter(function(list) {
                return list.listGroupID === listGroupID;
            }) || []).map(listToMenuItem),
            onClick: function() {}
        };
    }, [
        lists,
        listToMenuItem,
        openListGroupID
    ]);
    var renderMenuItem = (0,react.useCallback)(function(item) {
        if (item === null) return null;
        if (/*#__PURE__*/ (0,react.isValidElement)(item)) return item;
        var id = item.id, title = item.title, _elementProps = item.elementProps, elementProps = _elementProps === void 0 ? {} : _elementProps, header = item.header;
        var isCheckbox = true;
        if (header) {
            if (!title) return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}, id));
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ListSubheader/* default */.Z, ListsShowcaseMenu_objectSpread({}, elementProps, {
                children: title
            }), id));
        }
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* MenuItem */.sN, ListsShowcaseMenu_objectSpread({}, item, {
            checkbox: isCheckbox
        }), id));
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(ListsShowcaseMenu_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListsShowcaseMenu_Button, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((ClipboardTextMultipleIcon_default()), {
                    size: 24
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListsShowcaseMenu_Content, {
                ref: containerRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuList/* default */.Z, {
                    tabIndex: -1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListSubheader/* default */.Z, {
                            tabIndex: -1,
                            children: "Listat"
                        }, "lists-subheader"), 
                    ].concat(_toConsumableArray(listGroups.map(listGroupToMenuItem))).map(renderMenuItem)
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./components/company/CompanyLogo.tsx
var CompanyLogo = __webpack_require__(60733);
;// CONCATENATED MODULE: ./components/Flip.tsx



function Flip_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Flip_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Flip_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Flip_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Flip_templateObject() {
    var data = Flip_taggedTemplateLiteral([
        "\n  display: block;\n  position: relative;\n\n  transition: height ",
        "ms cubic-bezier(0.25, 1, 0.5, 1);\n"
    ]);
    Flip_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Flip_templateObject1() {
    var data = Flip_taggedTemplateLiteral([
        "\n  display: flex;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n\n  > * {\n    position: absolute;\n    top: 0;\n    margin: 0;\n  }\n\n  > :last-of-type:not(:first-of-type) {\n    opacity: 0;\n  }\n"
    ]);
    Flip_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Flip_templateObject2() {
    var data = Flip_taggedTemplateLiteral([
        "\n  0% {\n    transform: translateY(-100%);\n  }\n  100% {\n    transform: translateY(0%);\n  }\n"
    ]);
    Flip_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Flip_templateObject3() {
    var data = Flip_taggedTemplateLiteral([
        "\n  0% {\n    opacity: 1;\n    transform: translateY(0%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(100%);\n  }\n"
    ]);
    Flip_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Flip_templateObject4() {
    var data = Flip_taggedTemplateLiteral([
        "\n  > span:first-of-type {\n    opacity: 0;\n  }\n\n  > .container {\n    > .current {\n      animation: ",
        " ",
        "ms cubic-bezier(0.25, 1, 0.5, 1);\n    }\n\n    > .previous {\n      animation: ",
        " ",
        "ms cubic-bezier(0.25, 1, 0.5, 1);\n    }\n  }\n"
    ]);
    Flip_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = Flip_taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = Flip_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
var ANIMATION_DURATION_IN_MS = 1000;
var flipStyle = (0,styled_components_browser_esm/* css */.iv)(Flip_templateObject(), ANIMATION_DURATION_IN_MS);
var flipContainerStyle = (0,styled_components_browser_esm/* css */.iv)(Flip_templateObject1());
var flipCurrentAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(Flip_templateObject2());
var flipPreviousAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(Flip_templateObject3());
var flipAnimateStyle = (0,styled_components_browser_esm/* css */.iv)(Flip_templateObject4(), flipCurrentAnimation, ANIMATION_DURATION_IN_MS, flipPreviousAnimation, ANIMATION_DURATION_IN_MS);
var Flip_Container = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a5e2d290-0"
})(_templateObject5(), flipStyle, function(props) {
    return props.$animate ? flipAnimateStyle : null;
});
var Animated = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a5e2d290-1"
})(_templateObject6(), flipContainerStyle);
var Flip = function(_param) {
    var children = _param.children, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    var currentRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(children), current = ref[0], setCurrent = ref[1];
    var ref1 = (0,react.useState)(null), previous1 = ref1[0], setPrevious = ref1[1];
    var ref2 = (0,react.useState)(null), height = ref2[0], setHeight = ref2[1];
    var ref3 = (0,react.useState)(true), isHeightUpdated = ref3[0], setIsHeightUpdated = ref3[1];
    var isPreviousSet = previous1 !== null && previous1 !== current;
    (0,react.useEffect)(function() {
        setCurrent(function(previous) {
            setPrevious(previous);
            setIsHeightUpdated(true);
            return children;
        });
        var animationEndTimeout = setTimeout(function() {
            setPrevious(null);
        }, ANIMATION_DURATION_IN_MS);
        return function() {
            return clearTimeout(animationEndTimeout);
        };
    }, [
        children
    ]);
    (0,react.useEffect)(function() {
        if (!currentRef.current) return;
        if (isHeightUpdated === true) {
            setHeight(currentRef.current.getBoundingClientRect().height);
            setIsHeightUpdated(false);
        }
    }, [
        isHeightUpdated
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Flip_Container, {
        $animate: isPreviousSet,
        style: height !== null ? {
            height: height
        } : {},
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", Flip_objectSpread({
                ref: currentRef
            }, props, {
                children: current
            })),
            isPreviousSet && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Animated, {
                className: "container",
                "aria-hidden": true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", Flip_objectSpread({}, props, {
                        className: "current",
                        children: current
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", Flip_objectSpread({}, props, {
                        className: "previous",
                        children: previous1
                    }))
                ]
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./components/frontpage/ListsShowcaseCompany.tsx










function ListsShowcaseCompany_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ListsShowcaseCompany_templateObject() {
    var data = ListsShowcaseCompany_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: ",
        "px;\n  border-bottom: 2px solid ",
        ";\n  outline: none;\n  z-index: 1;\n\n  box-sizing: border-box;\n\n  transition: box-shadow 100ms ease;\n\n  &:first-of-type {\n    border-radius: ",
        "px ",
        "px 0 0;\n\n    &:after {\n      top: 0;\n      height: calc(100% + 2px);\n      border-radius: ",
        "px ",
        "px 0 0;\n    }\n  }\n\n  &:last-of-type {\n    border-radius: 0 0 ",
        "px ",
        "px;\n    border-bottom: none;\n\n    &:after {\n      height: calc(100% + 2px);\n      border-radius: 0 0 ",
        "px ",
        "px;\n    }\n  }\n\n  &:first-of-type:last-of-type {\n    border-radius: ",
        "px;\n  }\n\n  &[aria-selected='true'] {\n    background-color: ",
        ";\n\n    &:after {\n      display: block;\n      border: 2px solid ",
        ";\n    }\n  }\n\n  &:after {\n    content: '';\n    display: none;\n    position: absolute;\n    left: 0;\n    top: -2px;\n    width: 100%;\n    height: calc(100% + 4px);\n    border: 2px solid transparent;\n    border-radius: inherit;\n    pointer-events: none;\n\n    box-sizing: border-box;\n  }\n\n  &:hover {\n    background-color: ",
        ";\n    box-shadow: 0 0 11px rgba(149, 157, 165, 0.15);\n    z-index: 2;\n\n    &:after {\n      display: block;\n      border: 2px solid ",
        ";\n    }\n\n    > button {\n      opacity: 1;\n    }\n  }\n\n  &:active,\n  &:focus {\n    background-color: ",
        ";\n\n    &:after {\n      display: block;\n      border: 2px solid ",
        ";\n    }\n\n    > button {\n      opacity: 1;\n    }\n  }\n\n  small {\n    display: block;\n    margin-top: 0.2rem;\n    font-size: 0.8rem;\n    color: ",
        ";\n  }\n\n  p {\n    display: flex;\n    margin-bottom: 2px;\n\n    > svg {\n      // margin-bottom: -2px;\n      color: ",
        ";\n    }\n  }\n\n  ",
        " {\n    margin: 0 1.5rem;\n  }\n\n  ",
        ":first-of-type {\n    flex: 1;\n  }\n\n  ",
        ":last-of-type {\n    flex-shrink: 0;\n  }\n"
    ]);
    ListsShowcaseCompany_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var ListsShowcaseCompany_ListItem = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-536dfd91-0"
})(ListsShowcaseCompany_templateObject(), Theme/* compactCompanyRowHeight */.Pr, Theme/* Color.background */.Il.background, Theme/* borderRadius */.E0, Theme/* borderRadius */.E0, Theme/* borderRadius */.E0, Theme/* borderRadius */.E0, Theme/* borderRadius */.E0, Theme/* borderRadius */.E0, Theme/* borderRadius */.E0, Theme/* borderRadius */.E0, Theme/* borderRadius */.E0, Theme/* Color.select */.Il.select, Theme/* Color.primary */.Il.primary, Theme/* Color.hover */.Il.hover, Theme/* Color.secondary */.Il.secondary, Theme/* Color.select */.Il.select, Theme/* Color.primary */.Il.primary, Theme/* Color.disabled */.Il.disabled, (0,polished_esm/* transparentize */.DZ)(0.5, Theme/* Color.black */.Il.black), CompanyListStyle/* Logo */.TR, CompanyListStyle/* Section */.$0, CompanyListStyle/* Section */.$0);
var ListsShowcaseCompany = function(listItem) {
    var businessID = listItem.businessID, name = listItem.name, logo = listItem.logo, url = listItem.url;
    var companyLogo = (0,react.useMemo)(function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(CompanyLogo/* CompanyLogo */.D, {
            absolutePath: true,
            logo: logo
        });
    }, [
        logo === null || logo === void 0 ? void 0 : logo.path
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: url,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListsShowcaseCompany_ListItem, {
            tabIndex: -1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyListStyle/* Logo */.TR, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flip, {
                        children: companyLogo
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyListStyle/* Section */.$0, {
                    flex: true,
                    width: null,
                    className: "name",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flip, {
                                children: name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flip, {
                                children: businessID
                            })
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/frontpage/ListsShowcaseList.tsx








function ListsShowcaseList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ListsShowcaseList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ListsShowcaseList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ListsShowcaseList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ListsShowcaseList_templateObject() {
    var data = ListsShowcaseList_taggedTemplateLiteral([
        "\n  width: min(calc(100vw - 16px), 400px);\n  height: 325px;\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n  overflow: hidden;\n\n  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 80%, rgba(0, 0, 0, 0) 100%);\n  pointer-events: none;\n"
    ]);
    ListsShowcaseList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var ListsShowcaseList_Container = styled_components_browser_esm/* default.aside.withConfig */.ZP.aside.withConfig({
    componentId: "sc-6fdafd7c-0"
})(ListsShowcaseList_templateObject(), Theme/* Color.white */.Il.white, Theme/* borderRadius */.E0);
var changeItemName = function(id, name) {
    return function(items) {
        var index = items.findIndex(function(item) {
            return item.listItemID === id;
        });
        items[index].name = name;
        return items;
    };
};
var changeItemLogo = function(id, logo) {
    return function(items) {
        var index = items.findIndex(function(item) {
            return item.listItemID === id;
        });
        items[index].logo = logo ? {
            path: logo
        } : null;
        return items;
    };
};
var ListsShowcaseList = function() {
    var isSmall = (0,useBreakPoint/* useBreakPoint */.P)('small');
    var containerRef = (0,react.useRef)(null);
    var isVisible = (0,useOnScreen/* useOnScreen */.R)(containerRef, {
        rootMargin: "".concat(isSmall ? '-30%' : '-350px')
    });
    var ref = (0,react.useState)(lists[4].items), items = ref[0], setItems = ref[1];
    var ref1 = (0,react.useState)(0), step1 = ref1[0], setStep = ref1[1];
    (0,react.useEffect)(function() {
        if (!isVisible) return;
        var animate = function() {
            return setStep(function(step) {
                if (step === 1) setItems(changeItemLogo(26381, '/demoCompany2.png'));
                if (step === 2) setItems(changeItemName(26384, 'Yritys 1 Oy Ab'));
                if (step === 4) setItems(changeItemLogo(26376, '/demoCompany3.png'));
                if (step === 5) setItems(changeItemName(26378, 'Yritys 3 Ltd'));
                if (step === 6) setItems(changeItemName(26384, 'Yritys 1 Oy'));
                if (step === 7) setItems(changeItemLogo(26376, null));
                if (step === 9) setItems(changeItemLogo(26381, null));
                if (step === 10) setItems(changeItemName(26378, 'Yritys 3'));
                return (step + 1) % 12;
            });
        };
        var timeout = setTimeout(animate, 500);
        var interval = setInterval(animate, 1000);
        return function() {
            clearTimeout(timeout);
            clearInterval(interval);
        };
    }, [
        isVisible
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ListsShowcaseList_Container, {
        ref: containerRef,
        children: items.map(function(item) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ListsShowcaseCompany, ListsShowcaseList_objectSpread({}, item), item.listItemID);
        })
    }));
};

;// CONCATENATED MODULE: ./components/frontpage/ListsShowcase.tsx










function ListsShowcase_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ListsShowcase_templateObject() {
    var data = ListsShowcase_taggedTemplateLiteral([
        "\n  ",
        "\n  min-height: 20rem;\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n\n  > div {\n    > h3 {\n      position: relative;\n      display: flex;\n      align-items: center;\n      font-size: 2.5rem;\n      font-weight: bold;\n\n      > .badge {\n        margin-left: 16px;\n        margin-bottom: -4px;\n      }\n    }\n\n    > h5 {\n      padding-left: calc(64px + 13px);\n      opacity: 0.7;\n    }\n\n    > p {\n      margin-top: 12px;\n      padding-left: calc(64px + 13px);\n      max-width: 65ch;\n      font-size: 1.1rem;\n      opacity: 0.6;\n    }\n  }\n"
    ]);
    ListsShowcase_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ListsShowcase_templateObject1() {
    var data = ListsShowcase_taggedTemplateLiteral([
        "\n  display: inline-flex;\n  margin-right: 16px;\n  padding: 1rem;\n  background-color: ",
        ";\n  border-radius: 50%;\n  color: ",
        ";\n"
    ]);
    ListsShowcase_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ListsShowcase_templateObject2() {
    var data = ListsShowcase_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:nth-of-type(1) {\n    transform: translateX(20%);\n\n    > div {\n      // transform: rotate3d(0.5, 1, 0, 8deg);\n      filter: drop-shadow(1.5rem -1.5rem 3rem rgba(0, 0, 0, 0.2));\n    }\n  }\n\n  &:nth-of-type(2) {\n    transform: translateX(-20%);\n\n    > h5 {\n      margin-left: 64px;\n\n      &::before {\n        content: '2';\n        right: 0;\n      }\n    }\n\n    > div {\n      // transform: rotate3d(-0.5, -1, 0, 8deg);\n      filter: drop-shadow(-1.5rem -1.5rem 3rem rgba(0, 0, 0, 0.2));\n    }\n  }\n\n  &:nth-of-type(3) {\n    transform: translateX(10%);\n\n    > h5 {\n      &::before {\n        content: '3';\n      }\n    }\n\n    > div {\n      // transform: rotate3d(1, -1, 0, 8deg);\n      filter: drop-shadow(1.5rem 1.5rem 3rem rgba(0, 0, 0, 0.2));\n    }\n  }\n\n  &:not(:last-of-type) {\n    margin: 2rem 0;\n  }\n\n  > h5 {\n    position: relative;\n    width: min(100%, 400px);\n\n    &::before {\n      content: '1';\n      position: absolute;\n      margin: -32px 0 0 -32px;\n      width: 32px;\n      height: 32px;\n      font-size: 18px;\n      font-weight: bold;\n      text-align: center;\n      line-height: 32px;\n      background-color: ",
        ";\n      border-radius: 50%;\n      color: ",
        ";\n    }\n  }\n\n  > div {\n    transform: translateZ(0);\n  }\n\n  @media (max-width: ",
        "px) {\n    &:nth-of-type(1),\n    &:nth-of-type(2),\n    &:nth-of-type(3) {\n      transform: none;\n    }\n  }\n\n  @media (max-width: ",
        "px) {\n    margin-top: 72px;\n    flex-direction: column;\n\n    &:nth-of-type(2) {\n      flex-direction: column-reverse;\n\n      > h5 {\n        margin-left: 0;\n\n        &::before {\n          right: auto;\n        }\n      }\n    }\n\n    > h5 {\n      margin-bottom: 32px;\n\n      &::before {\n        margin: -42px 0 0 0;\n      }\n    }\n  }\n"
    ]);
    ListsShowcase_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var ListsShowcase_Content = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-20ec6e09-0"
})(ListsShowcase_templateObject(), Theme/* layoutStyles */.pG);
var ListsShowcase_Icon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-20ec6e09-1"
})(ListsShowcase_templateObject1(), Theme/* Color.primary */.Il.primary, Theme/* Color.background */.Il.background);
var Section = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-20ec6e09-2"
})(ListsShowcase_templateObject2(), Theme/* Color.primary */.Il.primary, Theme/* Color.white */.Il.white, Theme/* breakPoint.medium */.dV.medium, Theme/* breakPoint.small */.dV.small);
var ListsShowcase = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ListsShowcase_Content, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "h3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListsShowcase_Icon, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((ClipboardTextMultipleIcon_default()), {
                                size: 28
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "frontPage.showcase.lists.title",
                            defaultMessage: "Listat"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                            plain: true,
                            children: "Ilmainen"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "frontPage.showcase.lists.subtitle",
                        defaultMessage: "Automaattisesti p\xe4ivittyv\xe4 toimittajarekisteri"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body1",
                    children: "Esittelyss\xe4 Constlen Listat-ominaisuus. Listat on helppok\xe4ytt\xf6inen ja aina ajan tasalla oleva toimittajarekisteri, r\xe4\xe4t\xe4l\xf6ytyn\xe4 juuri sinun yrityksesi tarpeisiin. Listat-ominaisuus on saatavilla ilmaiseksi kaikille rekister\xf6ityneille k\xe4ytt\xe4jille."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "frontPage.showcase.lists.organization",
                                defaultMessage: "Organisoi toimittajarekisterisi helposti kansiorakenteen avulla."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "aria-hidden": true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListsShowcaseSidebar, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "aria-hidden": true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListsShowcaseMenu, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "frontPage.showcase.lists.addition",
                                defaultMessage: "Lis\xe4\xe4 yrityksi\xe4 rekisteriisi suoraan hakutuloksista tai yritysprofiilista."
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "frontPage.showcase.lists.updates",
                                defaultMessage: "Yritysrekisterisi p\xe4ivittyy automaattisesti. Uudet tiedot haetaan p\xe4ivitt\xe4in."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "aria-hidden": true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListsShowcaseList, {})
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/frontpage/CompanyShowcase.tsx








function CompanyShowcase_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyShowcase_templateObject() {
    var data = CompanyShowcase_taggedTemplateLiteral([
        "\n  padding: 0 2rem;\n  margin-bottom: 10rem;\n  box-sizing: border-box;\n\n  p {\n    font-size: 1.1rem;\n    line-height: 1.5;\n    opacity: 0.8;\n  }\n"
    ]);
    CompanyShowcase_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyShowcase_templateObject1() {
    var data = CompanyShowcase_taggedTemplateLiteral([
        "\n  position: relative;\n  flex-shrink: 0;\n  width: 35rem;\n  height: 35rem;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n\n  box-sizing: border-box;\n\n  @media (max-width: ",
        "px) {\n    margin: 4rem 6rem;\n    height: 20rem;\n    border-radius: 1rem;\n  }\n\n  @media (max-width: ",
        "px) {\n    margin: 0 0 2rem 0 !important;\n    width: 100%;\n  }\n"
    ]);
    CompanyShowcase_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanyShowcase_templateObject2() {
    var data = CompanyShowcase_taggedTemplateLiteral([
        "\n  margin: 7rem auto 8rem auto;\n  max-width: 750px;\n  text-align: center;\n  background: none;\n  z-index: 1;\n\n  h2 {\n    margin-top: 2rem;\n    margin-bottom: 1.2rem;\n    font-weight: bold;\n\n    @media (max-width: ",
        "px) {\n      font-size: 2.5rem;\n    }\n  }\n"
    ]);
    CompanyShowcase_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompanyShowcase_templateObject3() {
    var data = CompanyShowcase_taggedTemplateLiteral([
        "\n  display: inline-flex;\n  padding: 1rem;\n  background-color: ",
        ";\n  border-radius: 50%;\n  color: ",
        ";\n"
    ]);
    CompanyShowcase_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CompanyShowcase_templateObject4() {
    var data = CompanyShowcase_taggedTemplateLiteral([
        "\n  min-height: 20rem;\n  margin-top: 2rem;\n\n  section {\n    display: flex;\n    align-items: center;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    padding: 0 4rem;\n    width: 100%;\n    max-width: 1920px;\n    min-height: 20rem;\n\n    box-sizing: border-box;\n\n    &.left {\n      > div {\n        margin-right: 0rem;\n      }\n\n      ",
        " {\n        filter: drop-shadow(-2.5rem 2.5rem 3rem rgba(0, 0, 0, 0.3));\n      }\n\n      ",
        " {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    &.right {\n      flex-direction: row-reverse;\n\n      > div {\n        margin-left: 0rem;\n      }\n\n      ",
        " {\n        filter: drop-shadow(2.5rem 2.5rem 3rem rgba(0, 0, 0, 0.5));\n      }\n\n      h3,\n      p {\n        text-align: right;\n      }\n    }\n\n    > div {\n      max-width: 600px;\n\n      h3 {\n        position: relative;\n        font-weight: bold;\n        font-size: 2.5rem;\n        margin-bottom: 1rem;\n\n        ",
        " {\n          position: absolute;\n          top: -5rem;\n          right: 0;\n        }\n      }\n\n      p {\n        opacity: 0.6;\n      }\n    }\n\n    @media (max-width: ",
        "px) {\n      flex-direction: column !important;\n    }\n\n    @media (max-width: ",
        "px) {\n      padding: 0;\n      margin-bottom: 5rem;\n\n      > div:last-child {\n        margin: 0;\n      }\n\n      h3,\n      p {\n        text-align: center !important;\n      }\n    }\n  }\n"
    ]);
    CompanyShowcase_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
var CompanyShowcase_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52cd654e-0"
})(CompanyShowcase_templateObject());
var CompanyShowcase_Img = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52cd654e-1"
})(CompanyShowcase_templateObject1(), Theme/* breakPoint.medium */.dV.medium, Theme/* breakPoint.small */.dV.small);
var CompanyShowcase_Info = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52cd654e-2"
})(CompanyShowcase_templateObject2(), Theme/* breakPoint.small */.dV.small);
var CompanyShowcase_Icon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52cd654e-3"
})(CompanyShowcase_templateObject3(), Theme/* Color.primary */.Il.primary, Theme/* Color.background */.Il.background);
var CompanyShowcase_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52cd654e-4"
})(CompanyShowcase_templateObject4(), CompanyShowcase_Img, CompanyShowcase_Icon, CompanyShowcase_Img, CompanyShowcase_Icon, Theme/* breakPoint.medium */.dV.medium, Theme/* breakPoint.small */.dV.small);
var CompanyShowcase = function(param) {
    var children = param.children;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(CompanyShowcase_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyShowcase_Content, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "left",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyShowcase_Img, {
                        style: {
                            backgroundImage: "url(".concat((0,utils/* imageFromCDN */.wg)('/company_mockup.png'), ")")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "h3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyShowcase_Icon, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((FolderOpenIcon_default()), {
                                            size: 28
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "frontPage.showcase.company.title",
                                        defaultMessage: "Rikkaat yritysprofiilit"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "frontPage.showcase.company.text",
                                    defaultMessage: "Constle huolehtii siit\xe4 ett\xe4 k\xe4yt\xf6ss\xe4si on aina ajan tasalla olevat ja automaattisesti p\xe4ivittyv\xe4t yritystiedot. Voit my\xf6s itse t\xe4ydent\xe4\xe4 omaa yritysprofiiliasi."
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./pages/index.tsx

























function pages_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function pages_templateObject() {
    var data = pages_taggedTemplateLiteral([
        "\n  background-image: url('/constle-stripes-long.svg');\n  background-position: center 55%;\n  background-repeat: no-repeat;\n  background-size: 100% 4000px;\n\n  @media (max-width: 900px) {\n    background-image: none;\n  }\n"
    ]);
    pages_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function pages_templateObject1() {
    var data = pages_taggedTemplateLiteral([
        "\n    padding: calc(3rem + ",
        "px) 0 9rem 0;\n    background-color: ",
        ";\n    // https://unsplash.com/photos/VLPUm5wP5Z0\n    background-image: linear-gradient(198deg, ",
        ", ",
        "),\n      url(",
        ");\n    background-position: center 20%;\n    background-size: cover;\n    box-shadow: none;\n\n    @media (max-width: 750px) {\n      padding: 6rem 0 8rem 0;\n      text-align: center;\n\n      background-image: linear-gradient(to bottom, ",
        ", ",
        "),\n        url(",
        ");\n    }\n\n    > div {\n      ",
        "\n      position: relative;\n    }\n\n    img {\n      max-width: 100%;\n    }\n\n    h1 {\n      margin: 0 0 0.5rem 0;\n      font-size: 2.5rem;\n      max-width: 30ch;\n      color: ",
        ";\n\n      > span {\n        color: ",
        ";\n      }\n\n      @media (max-width: ",
        "px) {\n        font-size: 2rem;\n      }\n    }\n\n    h2 {\n      margin: 0 0 0.3rem 0;\n      font-size: 1.4rem;\n      font-weight: 500;\n      color: ",
        ";\n\n      @media (max-width: 750px) {\n        font-size: 1.2rem;\n      }\n    }\n\n    p,\n    small {\n      margin: 0;\n      margin-top: 1rem;\n      max-width: 50%;\n      font-size: 1.1rem;\n      line-height: 1.6rem;\n      color: ",
        ";\n\n      @media (max-width: ",
        "px) {\n        max-width: 70%;\n      }\n\n      @media (max-width: ",
        "px) {\n        padding: 0 2rem;\n        max-width: 100%;\n        font-size: 1rem;\n        box-sizing: border-box;\n      }\n    }\n\n    small {\n      font-size: 0.7rem;\n      opacity: 0.3;\n    }\n\n    .MuiButtonBase-root {\n      margin: 24px 0 0 0 !important;\n\n      /* position: absolute;\n      margin-left: 0 !important;\n      left: calc(50% + 3rem);\n      top: 50%;\n      transform: translate(0, -50%);\n\n      @media (max-width: ",
        "px) {\n        left: auto;\n        right: 1rem;\n      }\n\n      @media (max-width: ",
        "px) {\n        position: relative;\n        margin-top: 2rem;\n        transform: none;\n      } */\n    }\n  "
    ]);
    pages_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function pages_templateObject2() {
    var data = pages_taggedTemplateLiteral([
        "\n    ",
        "\n    overflow: hidden;\n\n    a {\n      display: flex;\n    }\n\n    img {\n      max-width: 100%;\n    }\n  "
    ]);
    pages_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function pages_templateObject3() {
    var data = pages_taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    pages_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function pages_templateObject4() {
    var data = pages_taggedTemplateLiteral([
        "\n    margin-top: -6.7rem;\n\n    > h2 {\n      margin-bottom: 2.8rem;\n      font-weight: 500;\n      color: ",
        ";\n    }\n  "
    ]);
    pages_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function pages_templateObject5() {
    var data = pages_taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    pages_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function pages_templateObject6() {
    var data = pages_taggedTemplateLiteral([
        "\n    position: relative;\n    padding: 5rem 4rem;\n    ",
        "\n    overflow: hidden;\n\n    @media (max-width: ",
        "px) {\n      padding: 3rem;\n    }\n\n    h1 {\n      margin: 0 0 2rem 0;\n      color: ",
        ";\n\n      svg {\n        margin-right: 0.3rem;\n        opacity: 0.5;\n      }\n\n      @media (max-width: ",
        "px) {\n        font-size: 1.5rem;\n\n        svg {\n          margin-right: 0.2rem;\n          margin-bottom: -3px;\n        }\n      }\n    }\n\n    p {\n      font-size: 1.1rem;\n      line-height: 150%;\n      color: ",
        ";\n\n      @media (max-width: ",
        "px) {\n        font-size: 1rem;\n      }\n    }\n\n    > div:first-of-type {\n      position: absolute;\n      display: flex;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n\n      > div:first-of-type {\n        flex: 1;\n\n        @media (max-width: ",
        "px) {\n          display: none;\n        }\n      }\n\n      > div:last-of-type {\n        flex: 1;\n\n        // https://unsplash.com/photos/sb7RUrRMaC4\n        background-image: linear-gradient(to right, ",
        ", ",
        "),\n          url(",
        ");\n        background-position: center;\n        background-size: cover;\n        background-color: ",
        ";\n\n        @media (max-width: ",
        "px) {\n          background-image: linear-gradient(to right, ",
        ", ",
        "),\n            url(",
        ");\n        }\n      }\n    }\n\n    > div:last-of-type {\n      position: relative;\n      max-width: 55%;\n\n      @media (max-width: ",
        "px) {\n        max-width: 100%;\n      }\n    }\n  "
    ]);
    pages_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = pages_taggedTemplateLiteral([
        "\n    position: relative;\n    padding: 5rem 4rem;\n    ",
        "\n    background-color: ",
        ";\n    overflow: hidden;\n\n    @media (max-width: ",
        "px) {\n      padding: 2rem;\n    }\n\n    h1 {\n      margin: 0 0 2rem 0;\n      color: ",
        ";\n\n      svg {\n        margin-right: 0.3rem;\n        opacity: 0.5;\n      }\n\n      @media (max-width: ",
        "px) {\n        font-size: 1.5rem;\n\n        svg {\n          margin-right: 0.2rem;\n          margin-bottom: -3px;\n        }\n      }\n    }\n\n    p {\n      font-size: 1.1rem;\n      line-height: 150%;\n      color: ",
        ";\n\n      b {\n        display: block;\n        margin-bottom: 1rem;\n      }\n\n      @media (max-width: ",
        "px) {\n        font-size: 1rem;\n      }\n    }\n\n    .MuiButtonBase-root {\n      margin-left: 0 !important;\n      margin-top: 1.5rem;\n    }\n\n    > div:first-of-type {\n      position: absolute;\n      display: flex;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n\n      > div:first-of-type {\n        flex: 1;\n        background-color: ",
        ";\n\n        @media (max-width: ",
        "px) {\n          display: none;\n        }\n      }\n\n      > div:last-of-type {\n        flex: 1;\n\n        // https://unsplash.com/photos/YDVdprpgHv4\n        background-image: linear-gradient(to right, ",
        ", ",
        "),\n          url(",
        ");\n        background-position: center;\n        background-size: cover;\n        background-color: ",
        ";\n\n        @media (max-width: ",
        "px) {\n          background-image: linear-gradient(to right, ",
        ", ",
        "),\n            url(",
        ");\n        }\n      }\n    }\n\n    > div:last-of-type {\n      position: relative;\n      max-width: 55%;\n\n      @media (max-width: ",
        "px) {\n        max-width: 100%;\n      }\n    }\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = pages_taggedTemplateLiteral([
        "\n    display: flex;\n    ",
        "\n    margin-bottom: 4rem;\n    min-height: 260px;\n    border: 2px dashed ",
        ";\n    border-radius: ",
        "px;\n\n    @media (max-width: ",
        "px) {\n      flex-direction: column;\n    }\n\n    > div {\n      position: relative;\n      ",
        "\n      flex: 1;\n      background-position: center;\n      background-size: cover;\n\n      &:not(:last-of-type) {\n        margin-right: 2rem;\n      }\n\n      &:after {\n        content: '';\n        display: block;\n        padding-top: 69.86%;\n      }\n    }\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = pages_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    ",
        "\n    margin: 6rem auto;\n\n    h2 {\n      margin: 0.5rem 0 0 0;\n      font-weight: 600;\n      color: ",
        ";\n\n      @media (max-width: 750px) {\n        font-size: 1.2rem;\n      }\n    }\n\n    img {\n      margin-top: 1.7rem;\n      opacity: 0.5;\n    }\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = pages_taggedTemplateLiteral([
        "\n    padding: 8rem 0;\n    background-color: ",
        ";\n    // https://unsplash.com/photos/ESZRBtkQ_f8\n    background-image: linear-gradient(to right, ",
        ", ",
        "),\n      url(",
        ");\n    background-position: center 38%;\n    background-size: cover;\n    box-shadow: none;\n\n    @media (max-width: 750px) {\n      padding: 6rem 0 8rem 0;\n      text-align: center;\n\n      background-image: linear-gradient(to bottom, ",
        ", ",
        "),\n        url(",
        ");\n    }\n\n    > div {\n      ",
        "\n    }\n\n    img {\n      max-width: 100%;\n    }\n\n    h1 {\n      margin: 0;\n      font-size: 3rem;\n      color: ",
        ";\n\n      @media (max-width: ",
        "px) {\n        font-size: 2rem;\n      }\n    }\n\n    h2 {\n      margin: 0.5rem 0 0 0;\n      font-size: 1.8rem;\n      font-weight: 500;\n      color: ",
        ";\n\n      @media (max-width: 750px) {\n        font-size: 1.2rem;\n      }\n    }\n\n    p {\n      margin: 2rem 0 0 0;\n      max-width: 50%;\n      font-size: 1.2rem;\n      color: ",
        ";\n\n      @media (max-width: ",
        "px) {\n        max-width: 70%;\n      }\n\n      @media (max-width: ",
        "px) {\n        padding: 0 2rem;\n        max-width: 100%;\n        font-size: 1rem;\n        box-sizing: border-box;\n      }\n    }\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
var Page = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-acd6d1d7-0"
})(pages_templateObject());
var Styled = {
    Hero: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-acd6d1d7-1"
    })(pages_templateObject1(), Theme/* navbarHeight */.zP, Theme/* Color.secondary */.Il.secondary, (0,polished_esm/* transparentize */.DZ)(0.8, Theme/* Color.secondary */.Il.secondary), (0,polished_esm/* transparentize */.DZ)(0.3, Theme/* Color.secondary */.Il.secondary), (0,utils/* imageFromCDN */.wg)('/constle_hero_background.jpg'), (0,polished_esm/* transparentize */.DZ)(0.4, Theme/* Color.secondary */.Il.secondary), (0,polished_esm/* transparentize */.DZ)(0.6, Theme/* Color.secondary */.Il.secondary), (0,utils/* imageFromCDN */.wg)('/constle_hero_background.jpg'), Theme/* layoutStyles */.pG, Theme/* Color.white */.Il.white, Theme/* Color.primary */.Il.primary, Theme/* breakPoint.small */.dV.small, (0,polished_esm/* lighten */.$n)(0.2, Theme/* Color.primary */.Il.primary), Theme/* Color.white */.Il.white, Theme/* breakPoint.medium */.dV.medium, Theme/* breakPoint.small */.dV.small, Theme/* breakPoint.medium */.dV.medium, Theme/* breakPoint.small */.dV.small),
    VgBanners: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-acd6d1d7-2"
    })(pages_templateObject2(), Theme/* cardStyles */.F),
    Scaffold: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-acd6d1d7-3"
    })(pages_templateObject3(), Theme/* layoutStyles */.pG),
    Search: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-acd6d1d7-4"
    })(pages_templateObject4(), (0,polished_esm/* lighten */.$n)(0.2, Theme/* Color.primary */.Il.primary)),
    Content: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-acd6d1d7-5"
    })(pages_templateObject5(), Theme/* cardStyles */.F),
    About: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-acd6d1d7-6"
    })(pages_templateObject6(), Theme/* cardStyles */.F, Theme/* breakPoint.small */.dV.small, Theme/* Color.secondary */.Il.secondary, Theme/* breakPoint.small */.dV.small, (0,polished_esm/* darken */._j)(0.15, Theme/* Color.secondary */.Il.secondary), Theme/* breakPoint.small */.dV.small, Theme/* breakPoint.small */.dV.small, Theme/* Color.white */.Il.white, (0,polished_esm/* transparentize */.DZ)(0.8, Theme/* Color.white */.Il.white), (0,utils/* imageFromCDN */.wg)('/constle_about_background.png'), Theme/* Color.secondary */.Il.secondary, Theme/* breakPoint.small */.dV.small, Theme/* Color.white */.Il.white, (0,polished_esm/* transparentize */.DZ)(0.3, Theme/* Color.white */.Il.white), (0,utils/* imageFromCDN */.wg)('/constle_about_background.png'), Theme/* breakPoint.small */.dV.small),
    Callout: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-acd6d1d7-7"
    })(_templateObject7(), Theme/* cardStyles */.F, Theme/* Color.secondary */.Il.secondary, Theme/* breakPoint.small */.dV.small, (0,polished_esm/* lighten */.$n)(0.2, Theme/* Color.primary */.Il.primary), Theme/* breakPoint.small */.dV.small, Theme/* Color.white */.Il.white, Theme/* breakPoint.small */.dV.small, Theme/* Color.secondary */.Il.secondary, Theme/* breakPoint.small */.dV.small, Theme/* Color.secondary */.Il.secondary, (0,polished_esm/* transparentize */.DZ)(0.8, Theme/* Color.secondary */.Il.secondary), (0,utils/* imageFromCDN */.wg)('/constle_callout_background.png'), Theme/* Color.secondary */.Il.secondary, Theme/* breakPoint.small */.dV.small, Theme/* Color.secondary */.Il.secondary, (0,polished_esm/* transparentize */.DZ)(0.3, Theme/* Color.secondary */.Il.secondary), (0,utils/* imageFromCDN */.wg)('/constle_callout_background.png'), Theme/* breakPoint.small */.dV.small),
    Info: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-acd6d1d7-8"
    })(_templateObject8(), Theme/* layoutStyles */.pG, Theme/* Color.disabled */.Il.disabled, Theme/* borderRadius */.E0, Theme/* breakPoint.small */.dV.small, Theme/* cardStyles */.F),
    VastuuGroup: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-acd6d1d7-9"
    })(_templateObject9(), Theme/* layoutStyles */.pG, Theme/* Color.black */.Il.black),
    Footer: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-acd6d1d7-10"
    })(_templateObject10(), Theme/* Color.secondary */.Il.secondary, (0,polished_esm/* transparentize */.DZ)(0.4, Theme/* Color.secondary */.Il.secondary), (0,polished_esm/* transparentize */.DZ)(0.8, Theme/* Color.secondary */.Il.secondary), (0,utils/* imageFromCDN */.wg)('/constle_footer_background.png'), (0,polished_esm/* transparentize */.DZ)(0.4, Theme/* Color.secondary */.Il.secondary), (0,polished_esm/* transparentize */.DZ)(0.6, Theme/* Color.secondary */.Il.secondary), (0,utils/* imageFromCDN */.wg)('/constle_footer_background.png'), Theme/* layoutStyles */.pG, Theme/* Color.white */.Il.white, Theme/* breakPoint.small */.dV.small, (0,polished_esm/* lighten */.$n)(0.2, Theme/* Color.primary */.Il.primary), Theme/* Color.white */.Il.white, Theme/* breakPoint.medium */.dV.medium, Theme/* breakPoint.small */.dV.small)
};
var flippingPurposes = [
    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "frontPage.hero.purposeInformation",
        defaultMessage: "tietopankki"
    }),
    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "frontPage.hero.purposeRegister",
        defaultMessage: "toimittajarekisteri"
    }),
    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "frontPage.hero.purposeManagement",
        defaultMessage: "hallintaty\xf6kalu"
    }), 
];
var Home = function() {
    var ref = (0,useUser/* useUser */.a)(), isLoggedIn = ref.isLoggedIn, hasPremium = ref.hasPremium;
    var ref1 = (0,state/* useScopedState */.S)(recentlyUpdatedState, [
        'companies',
        'isLoading'
    ]), companies = ref1.companies, isLoading = ref1.isLoading, doLoadState = ref1.doLoadState;
    (0,react.useEffect)(function() {
        doLoadState().catch(console.error);
    }, []);
    var companyHistory = isLoggedIn ? (0,lib_companyHistory/* loadCompanyHistory */.d)() : [];
    var ref2 = (0,react.useState)(flippingPurposes[0]), purpose = ref2[0], setPurpose = ref2[1];
    (0,react.useEffect)(function() {
        var index = 0;
        var interval = setInterval(function() {
            index = (index + 1) % flippingPurposes.length;
            setPurpose(flippingPurposes[index]);
        }, 3000);
        return function() {
            return clearInterval(interval);
        };
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* FrontPage */.Ig, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Styled.Hero, {
                        children: [
                            !isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "frontPage.hero.slogan",
                                            defaultMessage: "Yksi tehokas tarjouslaskennan ja ty\xf6maajohtamisen yhdist\xe4v\xe4 prosessi"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "frontPage.hero.tagline",
                                            defaultMessage: "S\xe4\xe4st\xe4 aikaa, rahaa ja vaivaa"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "frontPage.hero.vastuuGroupText",
                                            defaultMessage: "Palvelu on kehitetty yhteisty\xf6ss\xe4 VastuuGroupin kanssa."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        href: "/login",
                                        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightIcon_default()), {}),
                                        children: "P\xe4ivit\xe4 tietosi"
                                    })
                                ]
                            }),
                            isLoggedIn && !hasPremium && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((DiamondIcon_default()), {}),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                id: "premium.hero.title",
                                                defaultMessage: "Constle Pro -j\xe4senyys"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "premium.hero.subtitle",
                                            defaultMessage: "J\xe4senen\xe4 nautit kaikista Constlen tuomista eduista"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "premium.hero.text",
                                            defaultMessage: "Constle on rakennusalan ammattilaisille kehitetty helppok\xe4ytt\xf6inen ty\xf6kalu, jonka avulla l\xf6yd\xe4t tarvitsemasi yhteisty\xf6kumppanit hetkess\xe4."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        href: "/premium",
                                        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightIcon_default()), {}),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "frontPage.premiumCallToAction",
                                            defaultMessage: "Tilaa Pro"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Styled.Scaffold, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Styled.Search, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((BriefcaseSearchIcon_default()), {}),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "frontPage.hero.searchLabel",
                                            defaultMessage: "Hae yrityksi\xe4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Omnibar.Omnibar, {})
                                ]
                            }),
                            !!companyHistory.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyCarousel, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "frontPage.recentlyUpdated.title",
                                    defaultMessage: "Viimeksi katsotut"
                                }),
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((HistoryIcon_default()), {}),
                                companies: companyHistory
                            }),
                            !isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Styled.Callout, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((ShieldCheckIcon_default()), {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                        id: "frontPage.findOutMore.title",
                                                        defaultMessage: "Paranna kilpailuetuasi kokeilemalla itse"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "frontPage.findOutMore.consumer.title",
                                                            defaultMessage: "Ty\xf6suoritteiden tilaajat"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                        id: "frontPage.findOutMore.consumer.text",
                                                        defaultMessage: "Constlen avulla voit olla varma siit\xe4, ett\xe4 toimittajarekisteriss\xe4si olevien kumppaneiden tiedot ovat aina ajan tasalla. Constlessa voit my\xf6s luoda uusia henkil\xf6kohtaisia listauksia tai jakaa n\xe4m\xe4 yrityksess\xe4si parilla klikkauksella. En\xe4\xe4 ei siis tarvitse mets\xe4st\xe4\xe4 kiireen keskell\xe4 tarvitsemiasi toimijoita, vaan l\xf6yd\xe4t ne hetkess\xe4 Constlen avulla."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "frontPage.findOutMore.provider.title",
                                                            defaultMessage: "Ty\xf6suoritteiden tarjoajat"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                        id: "frontPage.findOutMore.provider.text",
                                                        defaultMessage: "T\xe4ydent\xe4m\xe4ll\xe4 ja p\xe4ivitt\xe4m\xe4ll\xe4 omaa yrityst\xe4si koskevia tietoja tavoitat tehokkaasti kaikki tarvitsemasi toimijat. Voit my\xf6s lis\xe4t\xe4 kiinnostavuuttasi t\xe4ydent\xe4m\xe4ll\xe4 profiilisi mahdollisimman kattavasti. Profiilisi muokkaus on helppoa ja onnistuu parissa minuutissa."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                href: "login",
                                                endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightIcon_default()), {}),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "frontPage.findOutMore.registerButton",
                                                    defaultMessage: "Kokeile jo t\xe4n\xe4\xe4n"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchHero, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListsShowcase, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyShowcase, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Styled.Scaffold, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled.Scaffold, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyCarousel, {
                                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "frontPage.recentlyUpdated.title",
                                        defaultMessage: "Viimeksi p\xe4ivitetyt"
                                    }),
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((NewspaperVariantMultipleIcon_default()), {}),
                                    companies: companies,
                                    loading: isLoading
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled.VgBanners, {
                                children: Math.floor(new Date().getMinutes() / 30) % 0 == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    target: "_blank",
                                    href: "https://www.vastuugroup.fi/fi-fi/palvelut/luotettava-kumppani",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,utils/* imageFromCDN */.wg)('/banneri1_2021.jpg')
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    target: "_blank",
                                    href: "https://www.vastuugroup.fi/fi-fi/palvelut/valttikortti",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,utils/* imageFromCDN */.wg)('/banneri2_2021.jpg')
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Styled.VastuuGroup, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "frontPage.vastuugroup.textBefore",
                                    defaultMessage: "Yhteisty\xf6ss\xe4"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,utils/* imageFromCDN */.wg)('/vastuu_group_logo_musta.png'),
                                width: 240,
                                height: 35.866,
                                alt: "vastuu group logo"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [929,868,7840,9167,5963,4435,9975,1476,1453,9332,6717,9774,2888,179], function() { return __webpack_exec__(45301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);